module.exports = new __parcel__URL__("toolbar-button.d7a7094e.svg").toString();